module.exports = __webpack_public_path__ + "static/05-b6202f23c8746d2ae6cf4086cde81aa0.jpg";